// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BoxPlotTwoToneSvg from "@ant-design/icons-svg/es/asn/BoxPlotTwoTone";
import AntdIcon from '../components/AntdIcon';

var BoxPlotTwoTone = function BoxPlotTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotTwoToneSvg
  }));
};

BoxPlotTwoTone.displayName = 'BoxPlotTwoTone';
export default React.forwardRef(BoxPlotTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BoxPlotTwoTone.js
// module id = 679
// module chunks = 0